const MatchClocksFormatter = (timestamps) => {
    if (timestamps) {
        return  "Match Time(s): " + '\r\n' + timestamps.filter(Boolean).join('\r\n'); //New line after label and each timestamp
    } else {
        return "";
    }
};
export default MatchClocksFormatter;